// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"d3c10c4b","729":"042a5a88"}[chunkId] + ".css";
};